// sub-components
import Accordian from "../../components/Accordian";
import Modal from "../../components/Modal";

const HomeStyleGuide = () => {
	return (
		<div className="lavella page dark-mode-disabled">
			<section>
				<div className="cont">
					<p className="eyebrow">Eyebrow</p>
					<h1>H1: Style Guide</h1>
					<h2>H2: Style Guide</h2>
					<h3>H3: Style Guide</h3>
					<h4>H4: Style Guide</h4>
					<h5>H5: Style Guide</h5>
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed porta ex. Fusce nec ante augue. Proin laoreet convallis orci vel mattis. Integer sodales ante ac dignissim tincidunt. Cras luctus lobortis turpis non eleifend. Nullam mollis volutpat arcu. Duis quis orci vel justo fringilla sollicitudin ac ac sem. Ut interdum purus est, eu faucibus ligula convallis eu. Cras elementum, risus nec hendrerit egestas, nibh ante pulvinar nulla, a aliquam mi velit sit amet lacus.</p>
					<ul className="bullets">
						<li>Cras elementum, risus nec hendrerit egestas</li>
						<li>nibh ante pulvinar nulla</li>
						<li>aliquam mi velit sit amet lacus.</li>
					</ul>
					<p className="disclaimer">** Disclaimer text</p>

					<div className="table horizontal">
						<div className="hd row">
							<div className="col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>Column</p>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<p>100</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col">
								<p>300</p>
							</div>
						</div>
					</div>

					<div className="table vertical">
						<div className="row">
							<div className="hd col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>100</p>
							</div>
						</div>

						<div className="row">
							<div className="hd col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
						</div>

						<div className="row">
							<div className="hd col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>300</p>
							</div>
						</div>
					</div>

					<div className="table two-axis">
						<div className="row hd">
							<div className="col spacing">&nbsp;</div>
							<div className="hd col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>Column</p>
							</div>
							<div className="col">Totals</div>
						</div>

						<div className="row">
							<div className="hd col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col total green">
								<p>200</p>
							</div>
						</div>

						<div className="row">
							<div className="hd col">
								<p>Column</p>
							</div>
							<div className="col">
								<p>300</p>
							</div>
							<div className="col zero">
								<p>0</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col zero">
								<p>0</p>
							</div>
							<div className="col total red">
								<p>200</p>
							</div>
						</div>

						<div className="row">
							<div className="hd col">
								<p>Column</p>
							</div>
							<div className="col zero">
								<p>0</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col zero">
								<p>0</p>
							</div>
							<div className="col">
								<p>200</p>
							</div>
							<div className="col total orange">
								<p>200</p>
							</div>
						</div>
					</div>

					<div className="links">
						<a href="#" className="l-btn">
							Button
						</a>
						<a href="#" className="l-btn v2">
							Button
						</a>
						<a href="#" className="l-btn v3">
							Button
						</a>
					</div>

					<div className="card-layout halves info">
						<div className="card light">
							<p className="eyebrow">Eyebrow</p>
							<h2>Info</h2>
							<p>Lorem ipsum dolor sit amet</p>
						</div>
						<div className="card dark">
							<p className="eyebrow">Eyebrow</p>
							<h2>Info</h2>
							<p>Lorem ipsum dolor sit amet</p>
						</div>
					</div>

					<div className="card-layout theme">
						{["base", "red", "orange", "yellow", "green", "magenta", "purple", "cyan", "pink"].map((color) => (
							<div key={color} className={`card ${color}`}></div>
						))}
					</div>

					<div className="card-layout gradient">
						<div className="card orange-to-red"></div>
						<div className="card sunset"></div>
						<div className="card blue-to-cyan"></div>
						<div className="card dawn"></div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default HomeStyleGuide;
